// extracted by mini-css-extract-plugin
module.exports = {"downloadButtons":"WidgetFooterButtons_downloadButtons__24j1s"};